import {
  pickUpModal,
  furnitureModal,
  accessoryModal,
} from './modals'

export const shippingOptionsWording = {
  isBopus: {
    'Free Shipping':{
      title: "Pick Up In Store",
      isUpgrade: false,
      showModalButton: true,
      modal: pickUpModal,
    },
    "Zgallerie (BOPS)": {
      title: "Pick Up In Store",
      isUpgrade: false,
      showModalButton: true,
      modal: pickUpModal,
    },
  },
  isFurniture: {
    'Free Shipping':{
      title: "Free Shipping",
      isUpgrade: false,
      showModalButton: false,
      modal: furnitureModal,
    },
    "LtlEntryway": {
      title: "Entryway delivery",
      description: 'Delivery of packaged item only to the first room of your address',
      isUpgrade: false,
      showModalButton: true,
      modal: furnitureModal
    },
    "LtlWhiteGlove": {
      title: "White glove delivery",
      description: 'Delivery of the item to your room of choice, with light assembly and disposal of packing materials',
      isUpgrade: false,
      showModalButton: true,
      modal: furnitureModal
    },
  },
  accessory: {
    'Free Shipping':{
      title: "Free Shipping",
      isUpgrade: false,
      showModalButton: false,
      modal: accessoryModal,
    },
    "ParcelStandard": {
      title: 'Standard Parcel Shipping',
      isUpgrade: false,
      showModalButton: true,
      modal: accessoryModal,
    },
    "Zgallerie (Standard Plus)": {
      title: 'Get it faster with Standard Plus',
      isUpgrade: true,
      showModalButton: true,
      modal: accessoryModal,
    }
  }
}

export const orderConfirmationShippingOptionsWording = {
  ...shippingOptionsWording,
  accessory: {
    'Free Shipping':{
      title: "Free Shipping",
      isUpgrade: false,
      showModalButton: false,
      modal: accessoryModal,
    },
    "Zgallerie (Standard)": {
      title: 'Standard Shipping',
      isUpgrade: false,
      showModalButton: true,
      modal: accessoryModal,
    },
    "Zgallerie (Standard Plus)": {
      title: 'Standard Plus',
      isUpgrade: true,
      showModalButton: true,
      modal: accessoryModal,
    },
  }
}
